import React,{useState,useCallback,useEffect} from 'react'
import { Grid,Divider} from '@mui/material';
import { useStore } from 'store/StoreProvider'
import SelectedDRProfile from './components/selectedDR';
import AddFieldMenu from './components/form/form_builder/menu/Menu';
import FormBuilder from './components/form';
import useRandom from 'hooks/useNewField';
import { useSession } from 'hooks/SessionProvider';

function AppointmentForm() {
    const store=useStore();
    const data=store.getData();
    const { setActiveStep }= useSession();

    const [formFields, setFormFields] = useState(data?.FormFields);
    const handleAddField = useCallback(
      (fieldType: string, field_type_id: number) => {
        const { newFormField } = useRandom({ fieldType, field_type_id });
        setFormFields((prev: any) => [...prev, newFormField]);
      },
      [formFields]
    );
    useEffect(()=>{
      setActiveStep(2)
    },[])
  return (
    <Grid >
       <Grid>
         <SelectedDRProfile></SelectedDRProfile>
       </Grid>
      <Grid sx={{paddingTop:"20px",paddingBottom:"20px"}}>
         <Divider></Divider>
      </Grid>
      <Grid>
        <Grid sx={{paddingLeft:"10px",paddingRight:"10px"}}>
        <FormBuilder formFields={formFields} />
       
        </Grid>
      </Grid>
    </Grid>
  )
}

export default AppointmentForm